import {
  reactQueryGet,
  reactQueryPatch,
  reactQueryPost,
} from "@circle-react/helpers/backendRequestHelpers";
import { internalApi } from "@circle-react/helpers/urlHelpers";
import type { Chat } from "@circle-react/types/CommunityInbox/Chat";

const adminMarkAsRead = ({ id }: { id: number }) =>
  reactQueryPatch<unknown, object>(
    internalApi.communityInbox.adminMarkAsRead({ id }),
  );

const adminMarkAllAsRead = () =>
  reactQueryPatch<{ success: boolean }, object>(
    internalApi.communityInbox.adminMarkAllAsRead(),
  );

const memberMarkAsRead = ({ id }: { id: number }) =>
  reactQueryPatch<unknown, object>(
    internalApi.communityInbox.memberMarkAsRead({ id }),
  );

const pauseAi = ({ id }: { id: number }) =>
  reactQueryPatch<Chat, object>(internalApi.communityInbox.pauseAi({ id }));

const resumeAi = ({ id }: { id: number }) =>
  reactQueryPatch<Chat, object>(internalApi.communityInbox.resumeAi({ id }));

const unreadMemberChatsCount = () =>
  reactQueryGet(internalApi.communityInbox.unreadMemberChatsCount());

const unreadAdminPausedAiChatsCount = () =>
  reactQueryGet(internalApi.communityInbox.unreadAdminPausedAiChatsCount());

const previewChat = ({
  community_bot_profile,
  keep_conversation = false,
}: {
  community_bot_profile: object;
  keep_conversation?: boolean;
}) =>
  reactQueryPost(internalApi.communityInbox.preview(), {
    community_bot_profile,
    keep_conversation,
  });

const fetchChat = ({ id }: { id: number }) =>
  reactQueryGet(internalApi.communityInbox.show({ id }));

export const communityInboxApi = {
  adminMarkAsRead,
  adminMarkAllAsRead,
  memberMarkAsRead,
  previewChat,
  fetchChat,
  pauseAi,
  resumeAi,
  unreadMemberChatsCount,
  unreadAdminPausedAiChatsCount,
};
